import { Spin } from 'antd';
import { BarChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  horizontal?: boolean;
  stacked?: boolean;
  color?: string;
  dataSet?: string;
  xColumn?: string;
  yColumn?: string;
  showGrid?: boolean;
  xAxisLabel?: string;
  yAxisLabel?: string;
  yAxisMin?: number | null;
  yAxisMax?: number | null;
}
interface Data {
  categories: string[];
  series: Array<{ name: string; data: number[] }>;
}

function BarWidget({ instance }: WidgetRenderProps<Config>) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id,
    'bar',
    instance.config as Record<string, unknown>,
    instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return (
    <BarChart
      categories={data?.categories ?? []}
      series={data?.series ?? []}
      horizontal={instance.config.horizontal}
      stacked={instance.config.stacked}
      color={instance.config.color}
      showGrid={instance.config.showGrid}
      xAxisLabel={instance.config.xAxisLabel}
      yAxisLabel={instance.config.yAxisLabel}
    />
  );
}

export const barWidgetDef: WidgetDefinition<Config> = {
  type: 'bar',
  name: 'Bar Chart',
  description: 'Categorical comparison',
  icon: 'BarChartOutlined',
  category: 'chart',
  defaultTitle: 'Bar Chart',
  defaultConfig: { showGrid: true },
  minW: 4,
  minH: 4,
  defaultW: 6,
  defaultH: 6,
  component: BarWidget,
  settingsSchema: {
    fields: [
      { key: 'horizontal', label: 'Horizontal', type: 'boolean' },
      { key: 'stacked', label: 'Stacked', type: 'boolean' },
    ],
  },
};
